module.exports = __webpack_public_path__ + "img/401.6214efb2.png";